// src/controllers/services/constructionService.js
import { supabase } from './supabase';

const FALLBACK_STORAGE_KEY = 'nobrokerage_construction_services_fallback';

export const CONSTRUCTION_CATEGORIES = [
  'Civil Construction',
  'Electrical & Plumbing',
  'Piping Works',
  'Fitting & Panel Works',
  'Painting & Finishing'
];

export const INITIAL_CONSTRUCTION_SERVICES = [
  {
    id: 'c0000000-0000-0000-0000-000000000001',
    category: 'Civil Construction',
    name: 'Civil Construction',
    description: 'Makan aur dukan ki majboot buniyad, RCC column-beam schedule aur brickwork/plaster ka mukammal civil kaam.',
    icon: 'Hammer',
    image_url: 'https://images.unsplash.com/photo-1541888946425-d0fbb18615f3?auto=format&fit=crop&w=800&q=80',
    priority: 1,
    status: 'Active',
    show_in_footer: true
  },
  {
    id: 'c0000000-0000-0000-0000-000000000002',
    category: 'Electrical & Plumbing',
    name: 'Electrical Work',
    description: 'Concealed wiring, MCB distribution board setup, inverter connection aur safety earthing ka professional kaam.',
    icon: 'Zap',
    image_url: 'https://images.unsplash.com/photo-1621905251189-08b45d6a269e?auto=format&fit=crop&w=800&q=80',
    priority: 2,
    status: 'Active',
    show_in_footer: true
  },
  {
    id: 'c0000000-0000-0000-0000-000000000003',
    category: 'Electrical & Plumbing',
    name: 'Plumbing Work',
    description: 'Bathroom & kitchen sanitary fittings, leak-proof line fixing aur overhead water tank installation.',
    icon: 'Wrench',
    image_url: 'https://images.unsplash.com/photo-1585704032915-c3400ca199e7?auto=format&fit=crop&w=800&q=80',
    priority: 3,
    status: 'Active',
    show_in_footer: true
  },
  {
    id: 'c0000000-0000-0000-0000-000000000004',
    category: 'Fitting & Panel Works',
    name: 'PVC Panel Fitting',
    description: 'Deewaron aur ceiling ke liye 100% waterproof, termite-free aur designer decorative PVC panel installation.',
    icon: 'Layers',
    image_url: 'https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?auto=format&fit=crop&w=800&q=80',
    priority: 4,
    status: 'Active',
    show_in_footer: true
  },
  {
    id: 'c0000000-0000-0000-0000-000000000005',
    category: 'Fitting & Panel Works',
    name: 'ACP Fitting',
    description: 'Modern showroom aur building exterior front facade ke liye weather-proof ACP sheet cladding aur framing.',
    icon: 'Building2',
    image_url: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=800&q=80',
    priority: 5,
    status: 'Active',
    show_in_footer: true
  },
  {
    id: 'c0000000-0000-0000-0000-000000000006',
    category: 'Fitting & Panel Works',
    name: 'SS Fitting',
    description: 'Balcony railing, staircase handrails aur designer gates ke liye rust-proof high-grade Stainless Steel fitting.',
    icon: 'ShieldCheck',
    image_url: 'https://images.unsplash.com/photo-1590381105924-c72589b9ef3f?auto=format&fit=crop&w=800&q=80',
    priority: 6,
    status: 'Active',
    show_in_footer: true
  },
  {
    id: 'c0000000-0000-0000-0000-000000000007',
    category: 'Painting & Finishing',
    name: 'Painting / Colour Work',
    description: 'Double-coat putty, primer, interior luxury emulsion aur exterior weather-shield paint finishing ka kaam.',
    icon: 'Paintbrush',
    image_url: 'https://images.unsplash.com/photo-1589939705384-5185137a7f0f?auto=format&fit=crop&w=800&q=80',
    priority: 7,
    status: 'Active',
    show_in_footer: true
  },
  {
    id: 'c0000000-0000-0000-0000-000000000008',
    category: 'Piping Works',
    name: 'CPVC Piping',
    description: 'Garam aur thande paani (hot & cold water) supply ke liye high-temperature durable CPVC pipe network.',
    icon: 'Pipette',
    image_url: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?auto=format&fit=crop&w=800&q=80',
    priority: 8,
    status: 'Active',
    show_in_footer: true
  },
  {
    id: 'c0000000-0000-0000-0000-000000000009',
    category: 'Piping Works',
    name: 'UPVC Piping',
    description: 'Potable drinking water supply aur underground distribution ke liye lead-free chemical-resistant UPVC piping.',
    icon: 'Boxes',
    image_url: 'https://images.unsplash.com/photo-1513694203232-719a280e022f?auto=format&fit=crop&w=800&q=80',
    priority: 9,
    status: 'Active',
    show_in_footer: true
  },
  {
    id: 'c0000000-0000-0000-0000-000000000010',
    category: 'Piping Works',
    name: 'SWR Piping',
    description: 'Soil, Waste aur Rainwater drainage ke liye ring-fit leak-proof heavy-duty SWR pipeline setup.',
    icon: 'Store',
    image_url: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?auto=format&fit=crop&w=800&q=80',
    priority: 10,
    status: 'Active',
    show_in_footer: true
  }
];

export const getActiveConstructionServices = async () => {
  try {
    const { data, error } = await supabase
      .from('construction_services')
      .select('*')
      .eq('status', 'Active')
      .order('priority', { ascending: true })
      .order('created_at', { ascending: false });

    if (!error && data && data.length > 0) {
      return data;
    }
  } catch (err) {
    console.warn('Supabase fetch failed for construction services, checking fallback:', err);
  }

  // Fallback to localStorage or default seed list
  try {
    const raw = localStorage.getItem(FALLBACK_STORAGE_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed) && parsed.length > 0) {
        return parsed.filter(item => item.status === 'Active');
      }
    }
  } catch (e) {
    // ignore
  }

  return INITIAL_CONSTRUCTION_SERVICES;
};

export const getFooterConstructionServices = async () => {
  const allServices = await getActiveConstructionServices();
  return allServices.filter(item => item.show_in_footer !== false);
};
